import { useEffect } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";
import { cn } from "@/lib/utils";
import { useLocation } from "@/lib/locations";
import { getLocalContent } from "@/lib/city-content";

const getFaqs = (location: any) => {
  const localContent = getLocalContent(location.name, location.regionSlug, 'ru');
  return [
    { q: `Сколько стоит уборка дома в ${location.name}?`, a: `Стандартная уборка начинается от $149. Цена зависит от размера дома, типа услуги и частоты. Используйте наш онлайн-калькулятор для точной фиксированной цены — без предварительных визитов.` },
    ...localContent.uniqueFaqs.map(f => ({ q: f.question, a: f.answer })),
    { q: "Регулярная уборка дешевле разовой?", a: "Да! Еженедельная уборка экономит 35%, раз в две недели — 30%, ежемесячная — 20% по сравнению с разовой уборкой." },
    { q: "Нужно ли мне быть дома во время уборки?", a: "Нет. Большинство наших клиентов нет дома. Оставьте инструкции по входу при бронировании, и мы надёжно закроем ваш дом по завершении." },
    { q: "Вы застрахованы и лицензированы?", a: "Да. Uplevel Cleaning полностью лицензирован, застрахован и связан во всех наших зонах обслуживания." },
    { q: "Что такое гарантия 200%?", a: "Если вы не удовлетворены на 100%, мы бесплатно повторно уберём пропущенные зоны в течение 48 часов. Всё ещё недовольны? Полный возврат денег — без вопросов." },
    { q: "Как забронировать уборку?", a: "Бронируйте онлайн на uplevelcleaning.com менее чем за 60 секунд. Фиксированные прозрачные цены, без необходимости звонить по телефону." },
    { q: "Сколько длится уборка?", a: "Обычно от 2 до 5 часов в зависимости от размера и состояния дома." },
    { q: "Ваши средства безопасны для домашних животных и детей?", a: "Да. Мы используем профессиональные чистящие средства, безопасные для домашних животных и детей при правильном применении." },
  ];
};

export const RussianFAQ = ({ cityName }: { cityName: string }) => {
  const { ref, isVisible } = useScrollAnimation();
  const location = useLocation();
  const faqs = getFaqs(location);

  useEffect(() => {
    const id = "schema-ru-faq";
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement("script");
      el.setAttribute("type", "application/ld+json");
      el.setAttribute("id", id);
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "inLanguage": "ru",
      "mainEntity": faqs.map(faq => ({
        "@type": "Question",
        "name": faq.q,
        "acceptedAnswer": { "@type": "Answer", "text": faq.a },
      })),
    });
    return () => { document.getElementById(id)?.remove(); };
  }, [faqs]);

  return (
    <section className="py-24 bg-background">
      <div className="container max-w-4xl">
        <div ref={ref} className={cn("text-center mb-16 anim-fade-up", isVisible && "is-visible")}>
          <h2 className="text-3xl md:text-5xl font-bold mb-4">Часто задаваемые вопросы</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Всё, что вам нужно знать о нашем сервисе уборки в {cityName}.
          </p>
        </div>
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border rounded-xl px-6 bg-card shadow-sm">
              <AccordionTrigger className="text-left font-semibold text-base hover:text-primary transition-colors py-5">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
